var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading && _vm.list.length
    ? _c("div", [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              gap: "2rem",
              "max-width": "490px",
              "margin-top": "1rem"
            }
          },
          [
            _c("QualificationSelect", {
              staticStyle: { "max-width": "235px" },
              model: {
                value: _vm.qualificationTypeInBatch,
                callback: function($$v) {
                  _vm.qualificationTypeInBatch = $$v
                },
                expression: "qualificationTypeInBatch"
              }
            }),
            _vm._v(" "),
            _c(
              "b-overlay",
              {
                staticClass: "d-inline-block",
                attrs: {
                  show: _vm.busy,
                  rounded: "",
                  opacity: "0.6",
                  "spinner-small": "",
                  "spinner-variant": "secondary"
                }
              },
              [
                _c(
                  "b-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled:
                        !_vm.selectedLeads.length ||
                        !this.qualificationTypeInBatch
                    },
                    on: { click: _vm.setQualificationTypeInBatch }
                  },
                  [_vm._v("\n        Atualizar em lote\n      ")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-between flex-column" },
          [
            _c(
              "Table",
              {
                staticClass: "leads-table",
                staticStyle: { "margin-top": "1rem" }
              },
              [
                _c(
                  "TableHeader",
                  [
                    _c(
                      "TableRow",
                      _vm._l(_vm.leadsColumns, function(leadsCol, index) {
                        return _c(
                          "TableHead",
                          { key: `${leadsCol}-${index}` },
                          [
                            _c("ColumnHeader", {
                              attrs: {
                                sort: leadsCol.sort,
                                somatory: leadsCol.somatory,
                                columnName: leadsCol.name,
                                columnKey: leadsCol.key,
                                columnType: leadsCol.columnType,
                                currentColumnFiltered:
                                  _vm.currentColumnFiltered,
                                sortDirection: _vm.sortDirection,
                                dataList: _vm.list
                              },
                              on: {
                                sortListByKey: function($event) {
                                  return _vm.sortListByKey(leadsCol.key)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "TableBody",
                  _vm._l(_vm.list, function(item, idx) {
                    return _c(
                      "TableRow",
                      { key: `${item}-${idx}` },
                      [
                        _c(
                          "TableCell",
                          { staticStyle: { "min-width": "50px" } },
                          [
                            _c("b-form-checkbox", {
                              attrs: { size: "sm" },
                              on: {
                                change: value => _vm.setLeadInBatch(value, item)
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "min-width": "45px" } },
                          [_vm._v(_vm._s(idx + 1))]
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "min-width": "305px" } },
                          [
                            _c("RenderNameColumnValue", {
                              attrs: { name: item.name }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderNameColumnValue", {
                              attrs: {
                                name:
                                  item.primaryCNAECode +
                                  "-" +
                                  item.primaryCNAEDescription
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [_vm._v(_vm._s(item.state))]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderNameColumnValue", {
                              attrs: {
                                name: item.cityCode + "-" + item.cityDescription
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                                width: "200px"
                              }
                            },
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: { "social-number": item.socialNumber }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "outline-primary",
                                    size: "sm"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.copySocialNumber(
                                        item.socialNumber
                                      )
                                    }
                                  }
                                },
                                [_c("b-icon-clipboard")],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderDateColumnValue", {
                              attrs: { value: item.creationDate }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c(
                              "b-overlay",
                              {
                                staticClass: "d-inline-block",
                                attrs: {
                                  show: _vm.busy,
                                  rounded: "",
                                  opacity: "0.6",
                                  "spinner-small": "",
                                  "spinner-variant": "secondary"
                                }
                              },
                              [
                                _c("QualificationSelect", {
                                  on: {
                                    input: function($event) {
                                      return _vm.changeQualificationType(item)
                                    }
                                  },
                                  model: {
                                    value: item.qualificationType,
                                    callback: function($$v) {
                                      _vm.$set(item, "qualificationType", $$v)
                                    },
                                    expression: "item.qualificationType"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "0.2rem" } },
                            [
                              _c(
                                "b-overlay",
                                {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    show: _vm.busyButton,
                                    rounded: "",
                                    opacity: "0.6",
                                    "spinner-small": "",
                                    "spinner-variant": "outline-primary"
                                  }
                                },
                                [
                                  _c(
                                    "BaseButtonComponent",
                                    {
                                      staticStyle: { padding: "1px 12px" },
                                      attrs: { variant: "tertiary-action" },
                                      on: {
                                        click: function($event) {
                                          return _vm.recordObservation(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Gravar\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-form-textarea", {
                                staticStyle: {
                                  "border-radius": "4px",
                                  outline: "none",
                                  border: "1px solid grey",
                                  width: "200px",
                                  height: "30px"
                                },
                                attrs: {
                                  id: "textarea",
                                  debounce: "1000",
                                  placeholder: "Observação",
                                  rows: "3",
                                  "max-rows": "6"
                                },
                                model: {
                                  value: item.observation,
                                  callback: function($$v) {
                                    _vm.$set(item, "observation", $$v)
                                  },
                                  expression: "item.observation"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }